import React from "react";
import PropTypes from "prop-types";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText, Label } from "../../../../components/Inputs";
import AddressForm from "../../../Company/components/wizard/AddressForm";
import PersonForm from "../../../Company/components/wizard/PersonForm";

const getState = (pModel = {}) => {
  const model = pModel || {};
  return {
    region: model.region || "",
    debitorKey: model.debitorKey || "",
    comment: model.comment || "",
    error: {
      region: null,
      debitorKey: null,
      // comment: null,
    },
  };
};

function DebitorTaskForm({
  forwardedRef,
  className = "",
  model = {
    company_id,
    name: "",
    region: "",
    debitorKey: "",
    address: {
      street: "",
      houseNumber: "",
      areaCode: "",
      city: "",
    },
    person,
    comment: "",
    status_id: 1,
  },
}) {
  const personFormRef = React.useRef(null);
  const addressFormRef = React.useRef(null);
  const [state, setState] = React.useState(getState(model));

  const handleChange = React.useCallback((key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
      error: {
        ...prev.error,
        [key]: value === "",
      },
    }));
  }, []);

  const validate = React.useCallback(() => {
    const originalModel = model || {};
    const { error, ...newModel } = state;
    // check if all values are set
    let isChanged = false;
    let isValid = true;
    Object.keys(newModel).forEach((key) => {
      if (newModel[key] !== originalModel[key]) {
        isChanged = true;
      }
      if (error[key] !== undefined && newModel[key] === "") {
        error[key] = true;
        isValid = false;
      }
    });

    setState((prev) => ({ ...prev, error }));
    if (!isValid) {
      return null;
    }

    // person (optional)
    const person = personFormRef.current.getModel();
    if (person) {
      const originalPerson = originalModel.person || {};
      newModel.person = {
        ...originalPerson,
        ...person,
      };
    }

    // address (required)
    const addressModel = addressFormRef.current.getModel();
    if (addressModel) {
      const { name, address } = addressModel;
      newModel.name = name;
      newModel.address = address;
    } else {
      return null;
    }
    return { ...originalModel, ...newModel };
  }, [model, state]);

  const getModel = React.useCallback(
    (initialize = false) => validate(initialize),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const { region, debitorKey, comment, error } = state;
  const { company_id, name, address, person } = model;
  const company = { company_id, name, address };

  return (
    <div className={className}>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top">
          <Label htmlFor="region">{`Region*`}</Label>
          <InputText
            id="region"
            className="w3-block w3-border"
            value={region}
            disabled={true}
            onChange={(event) => handleChange("region", event.target.value)}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top">
          <Label htmlFor="debitorKey">{`Kennung*`}</Label>
          <InputText
            id="debitorKey"
            className="w3-block w3-border"
            value={debitorKey}
            disabled={true}
            onChange={(event) => handleChange("debitorKey", event.target.value)}
          />
        </div>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top">
          <h4 className="no-margin-">{`Lieferanschrift*`}</h4>
          <AddressForm
            ref={addressFormRef}
            model={company}
            isVertical
            namePrefix="debitor_"
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top">
          <h4 className="no-margin-">{`Ansprechpartner`}</h4>
          <PersonForm ref={personFormRef} model={person} />
        </div>
      </div>
      <div className="pad-top">
        <Label htmlFor="comment">{`Bemerkungen`}</Label>
        <InputTextarea
          id="comment"
          className="w3-block w3-border"
          value={comment}
          rows={3}
          autoResize
          onChange={(event) => handleChange("comment", event.target.value)}
        />
      </div>
    </div>
  );
}

DebitorTaskForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
};

export default React.forwardRef((props, ref) => (
  <DebitorTaskForm {...props} forwardedRef={ref} />
));

/*
export default class DebitorTaskForm extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    model: PropTypes.object
  }
  static defaultProps = {
    className: '',
    model: {
      region: '',
      debitorKey: '',
      name: '',
      address: {
        street: '',
        houseNumber: '',
        areaCode: '',
        city: ''
      },
      comment: '',
      status_id: 1
    }
  }
  constructor(props) {
    super(props);
    const model = props.model || {};
    this.state = {
      region: model.region || '',
      debitorKey: model.debitorKey || '',
      comment: model.comment || '',
      error: {
        region: null,
        debitorKey: null,
        // comment: null,
      }
    };
  }
  validate = () => {
    const originalModel = this.props.model || {};
    const { error, ...model } = this.state;
    // check if all values are set
    let isChanged = false;
    let isValid = true;
    Object.keys(model).forEach(key => {
      if (model[key] !== originalModel[key]) {
        isChanged = true;
      }
      if (error[key] !== undefined && model[key] === '') {
        error[key] = true;
        isValid = false;
      }
    });

    this.setState({ error });
    if (!isValid) {
      return null;
    }
    
    // person (optional)
    const person = this.personForm.getModel();
    if (person) {
      const originalPerson = originalModel.person || {};
      model.person = {
        ...originalPerson,
        ...person
      };
    }

    // address (required)
    const addressModel = this.addressForm.getModel();
    if (addressModel) {
      const { name, address } = addressModel;
      model.name = name;
      // model.company_id = company_id;
      model.address = address;
    } else {
      return null;
    }
    return { ...originalModel, ...model };
  }
  getModel = (initialize = false) => {
    // console.log('DebitorTaskForm.getModel() - initialize:', initialize);
    const model = this.validate(initialize);
    return model;
  }
  render() {
    const {
      className,
      model: {
        company_id,
        name,
        address,
        person
      }
    } = this.props;
    const { region, debitorKey, comment, error } = this.state;
    const company = { company_id, name, address };
    return (
      <div className={className}>
        <div className="w3-row neg-margin-lr">
          <div className="w3-col s6 pad-lr pad-top">
            <Label htmlFor= "region">{`Region*`}</Label>
            <InputText
              id="region"
              className="w3-block w3-border"
              value={region}
              disabled={true}
              onChange={(event) => this.setState({region: event.target.value})}
            />
          </div>
          <div className="w3-col s6 pad-lr pad-top">
            <Label htmlFor= "debitorKey">{`Kennung*`}</Label>
            <InputText
              id="debitorKey"
              className="w3-block w3-border"
              value={debitorKey}
              disabled={true}
              onChange={(event) => this.setState({debitorKey: event.target.value})}
            />
          </div>
        </div>
        <div className="w3-row neg-margin-lr">
          <div className="w3-col s6 pad-lr pad-top">
            <h4 className="no-margin-">{`Lieferanschrift*`}</h4>
            <AddressForm
              ref={ref => this.addressForm = ref}
              model={company}
              isVertical
              namePrefix="debitor_"
            />
          </div>
          <div className="w3-col s6 pad-lr pad-top">
            <h4 className="no-margin-">{`Ansprechpartner`}</h4>
            <PersonForm
              ref={ref => this.personForm = ref}
              model={person}
              // workers={workers}
            />
          </div>
        </div>
        <div className="pad-top">
          <Label htmlFor= "comment">{`Bemerkungen`}</Label>
          <InputTextarea
            id= "comment"
            className="w3-block w3-border"
            value={comment}
            rows={3}
            autoResize
            onChange={(event) => this.setState({comment: event.target.value})}/>
        </div>
      </div>
    );
  }
}
*/
